import toast from "react-hot-toast";
import Axios, { AxiosError } from "axios";
import { getTimeToRead } from "@edgetier/utilities";
import { IRole, Route } from "@edgetier/watchtower-types";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";
import { axios } from "utilities/axios";
import { getServerError } from "utilities/get-server-error";

const removeRole = (role: IRole) => async () => {
    const { data } = await axios.delete<IRole>(Route.Role.replace(":roleId", role.roleId));
    return { ...data };
};
/**
 * Custom hook to remove an existing role
 * @param role      The role intended to be removed
 */
export const useRemoveRole = (role: IRole, configuration: UseMutationOptions<IRole, AxiosError, IRole> = {}) => {
    const queryClient = useQueryClient();

    const onSuccess = () => {
        queryClient.setQueryData<IRole[]>([Route.Roles], (roles): IRole[] => {
            return (roles ?? []).filter((existingRole) => existingRole.roleId !== role.roleId);
        });
        const successMessage = `Successfully removed ${role.role}`;
        toast.success(successMessage, { duration: getTimeToRead(successMessage, 1000) });
    };
    const onError = (error: unknown) => {
        if (Axios.isAxiosError(error)) {
            toast.error(getServerError(error));
        } else {
            toast.error("Failed to remove a role");
        }
    };

    const mutationSettings = { onSuccess, onError, ...configuration };
    return useMutation(removeRole(role), mutationSettings);
};
